import type { FC } from 'react'
import { useState } from 'react'

import { Input } from '@skytech/ui'
import CheckIcon from 'mdi-react/CheckIcon'
import CloseIcon from 'mdi-react/CloseIcon'

import { Translation } from '@/app/translations/Translation'

import type { PhoneBookType } from '../types'

import { PhoneBookItems } from './PhoneBookItems'

type Props = {
  scrollToNextSlide: (index: number) => void
  items: PhoneBookType[]
  selectedItem: PhoneBookType
  onClick: (item: PhoneBookType) => void
}

export const PhoneBooks: FC<Props> = ({ items, selectedItem, onClick, scrollToNextSlide }) => {
  const [searchPhoneBookName, setSearchPhoneBookName] = useState('')
  const [displayMenuInput, setDisplayMenuInput] = useState(false)

  const toggleDisplayMenuInput = () => {
    setDisplayMenuInput(!displayMenuInput)
  }

  return (
    <div className="flex w-full flex-shrink-0 snap-start flex-col md:px-5 lg:w-1/4">
      {/* //SearchBar */}
      <div className="flex w-full flex-col">
        <div className="flex items-center">
          <h3 className="lg:mb-2 lg:leading-10">
            <Translation id="Numbers" />
          </h3>
        </div>
        <div className="grow-0">
          <Input
            isFullWidth
            id="search"
            marginBottom={16}
            onChange={e => setSearchPhoneBookName(e.target.value?.toLowerCase() || '')}
          />
        </div>
      </div>
      {/* //Body */}
      <div className="mb-3 flex grow flex-col overflow-y-auto">
        {items?.map(option => (
          <div
            onClick={() => scrollToNextSlide(1)}
            role="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                scrollToNextSlide(1)
              }
            }}
            key={option.type}
            className=""
          >
            <PhoneBookItems
              item={option}
              selectedItem={selectedItem}
              onClick={onClick}
              searchPhrase={searchPhoneBookName}
            />
          </div>
        ))}
      </div>
      <div className={`relative grow-0 ${displayMenuInput ? 'block' : 'hidden'}`}>
        <Input className="h-8 w-4/5 lg:h-10" isFullWidth id="search" marginBottom={16} />
        <CheckIcon className="absolute right-10 top-1.5 cursor-pointer" size={20} />
        <CloseIcon
          onClick={toggleDisplayMenuInput}
          className="absolute right-4 top-1.5 cursor-pointer"
          size={20}
        />
      </div>
    </div>
  )
}
